import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const reducerName = 'deviceState';

/*
Man kan på hver gruppe tiføje en prop, som definerer placering og størrelse af vind-visning
        windPlacement: {
            left: '85.5vw', 
            top: '21vh', 
            width: '6.6vh'
        }
*/

const groups = [
    {
        deviceIds: [4, 5, 125],
        group: 'AVV',
        windStationId: '06183',
        rotation: -187.00, // rotationen på baggrundsbilledet ift. nord - RIGTIG

        coordinates: 'POINT(12.479 55.604)'
    },
    {
        deviceIds: [6],
        group: 'ESV',
        windStationId: '06081',
        rotation: -187.95,
        windPlacement: {
            left: '88vw', 
            top: '4.6vh', 
            width: '5.5vh',
            error: {
                top: '5.4vh'
            }
        },
        compassPlacement: {
            left: '77.5vw', 
            top: '5vh', 
            height: 14
        },
        coordinates: 'POINT(8.453 55.457)'




    },
    {
        deviceIds: [7],
        group: 'HEV',
        windStationId: '06108',
        rotation: -58.17,
        windPlacement: {
            left: '13vw', 
            top: '18vh', 
            width: '5.5vh',
            error: {
                top: '6vh'
            }
        },
        compassPlacement: {
            left: '11vw', 
            top: '2vh', 
            height: 15
        },
        coordinates: 'POINT(9.007 56.119)'
    },
    {
        deviceIds: [8],
        group: 'KYV',
        windStationId: '06156',
        rotation: -309.22,
        windPlacement: {
            error: {
                left: '86vw',
                top: '20vh',
                width: '4vh',
            }
        },
        coordinates: 'POINT(11.878 55.810)'
    },
    {
        deviceIds: [9, 10, 123],
        group: 'ASV',
        windStationId: '06068',
        rotation: -0.71,
        windPlacement: {
            left: '80vw', 
            top: '2.5vh', 
            width: '5.5vh',
            error: {
                top: '4vh',
            }
        },
        compassPlacement: {
            left: '86vw', 
            top: '3vh', 
            height: 14
        },
        coordinates:'POINT(11.084 55.660)'
    },
    {
        deviceIds: [11, 12, 13, 128],
        group: 'SSV',
        windStationId: '06073',
        rotation: -39.95,
        windPlacement: {
            left: '88vw', 
            top: '4vh', 
            width: '5.5vh',
        },
        compassPlacement: {
            left: '77.5vw', 
            top: '4vh', 
            height: 14
        },
        coordinates: 'POINT(10.346 56.248)'
    },
    {
        deviceIds: [14, 15],
        group: 'SKV',
        windStationId: '06159',
        rotation: -179.73,
        windPlacement: {
            left: '87vw',
            top: '22vh',
            error: {
                left: '88vw',
                top: '22vh',
                width: '4vh',
            }
        },
        compassPlacement: {
            left: '85vw', 
        },
        coordinates: 'POINT(9.616 55.513)'

    },

];

export const getAllDevices = createAsyncThunk(
    'deviceState/getAllDevices',
    async (_, { dispatch }) => {
        // Simulate async fetch of static device groups
        return groups;
    }
);

const initialState = {
    devices: groups,
    activeDevice: {},
    status: 'idle',
    error: null,
};

const deviceSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setActiveDevice: (state, action) => {
            // Always restore static device list
            const deviceId = localStorage.getItem('deviceId');
            const activeDevice = groups.find(group =>
                group.deviceIds.includes(Number(deviceId))
            );
            state.activeDevice = activeDevice || {};
        },
    },
    // extraReducers: (builder) => {
    //     builder
    //         //getAllDevices
    //         .addCase(getAllDevices.pending, (state) => {
    //             state.status = 'loading';
    //             state.error = null;
    //         })
    //         .addCase(getAllDevices.fulfilled, (state, action) => {
    //             state.status = 'succeeded';
    //             state.devices = action.payload;
    //         })
    //         .addCase(getAllDevices.rejected, (state, action) => {
    //             state.status = 'failed';
    //             state.error = action.payload || 'An error occurred';
    //         })
    // },
});

export const { setActiveDevice } = deviceSlice.actions;

export default deviceSlice.reducer;